import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history', // 使用history模式，需要后端配合
  base: process.env.BASE_URL,
  routes
})

// 路由白名单 - 不需要登录即可访问的页面
const whiteList = ['/', '/login', '/register', '/forgetPassword', '/ShopDetails', '/about']

// 路由守卫
router.beforeEach((to, from, next) => {
  // 可以在这里添加权限验证、加载动画等
  console.log('路由切换:', from.path, '->', to.path)

  // 判断用户是否已登录
  const isLoggedIn = store.getters.isLoggedIn

  if (isLoggedIn) {
    // 已登录用户可以访问所有页面
    next()
  } else {
    // 未登录用户只能访问白名单中的页面
    if (whiteList.includes(to.path)) {
      next()
    } else {
      // 重定向到登录页面，并记录当前页面路径，以便登录后返回
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }
})

router.afterEach((to, from) => {
  // 可以在这里添加页面访问统计等
})

export default router